import { Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";

@Injectable()

export class NavigationService {
    constructor(private location: Location, private router: Router, private route: ActivatedRoute) { }

    back() {
        return this.location.back();
    }

    forward() {
        return this.location.forward();
    }

    navigateTo(routeName: any[], extras = {}) {
        this.router.navigate(routeName, extras);
    }

    // router.navigate() commands don't parse "?query" embedded in a segment
    // string; navigateByUrl does. Use this for a full "path?query" string
    // (e.g. a stashed campaign redirect) instead of navigateTo().
    navigateByFullUrl(url: string) {
        return this.router.navigateByUrl(url);
    }

    getParam(param: string | number) {
        return this.route.snapshot.params[param];
    }

    navigateToUrl(site: any) {
        return window.open(site, "_blank");
    }
}
